import { j as t } from "./atoms-v218.js";
import U, { forwardRef as H, useState as w, useRef as N } from "react";
import { useFloating as V, useDismiss as W, useInteractions as Y } from "./atoms-v280.js";
import q from "./atoms-v2122.js";
import { Icon as J } from "./atoms-v217.js";
import { OverflowMenu as K, Menu as Q, MenuItems as X, MenuGroup as Z, MenuItem as O, MenuItemButton as $, Toggle as ee } from "./atoms-v2717.js";
import { isMenuGroup as te } from "./atoms-v2718.js";
import { shift as se, size as ne, autoUpdate as le } from "./atoms-v283.js";
import { arrow as oe } from "./atoms-v2719.js";
const re = 18, ie = H(
  ({
    ariaLabel: c,
    className: f,
    closeOnScroll: v = !1,
    colorTheme: i = "light",
    defaultSelected: R,
    defaultVisible: S = !1,
    disabled: d = !1,
    iconName: b,
    id: C,
    isOnlyClickable: m = !1,
    menu: s,
    onSelect: h,
    placement: I = "bottom-start",
    toggleAndMenuGap: T = 4,
    trigger: p
  }, k) => {
    const [o, r] = w(S), [u, y] = w(R), E = N(null), { context: F, floatingStyles: z, middlewareData: A, placement: P, refs: a } = V({
      middleware: [
        se(),
        ne({
          apply({ availableHeight: e, elements: n }) {
            Object.assign(n.floating.style, {
              maxHeight: `${e - re}px`
            });
          }
        }),
        oe({ element: E })
      ],
      onOpenChange: r,
      open: o,
      placement: I,
      whileElementsMounted: le
    }), _ = W(F, { ancestorScroll: v }), { getFloatingProps: D, getReferenceProps: g } = Y([_]), x = () => {
      r(!o);
    }, j = (e) => {
      h && h(e), y(e);
    }, M = (e) => {
      var n;
      (n = e.onClick) == null || n.call(e);
    }, G = q(A, "shift.x", 0) !== 0, L = () => {
      const e = {
        "aria-label": c,
        disabled: d,
        onClick: x,
        ref: a.setReference,
        ...g()
      };
      return p ? U.cloneElement(p, e) : /* @__PURE__ */ t.jsx(
        ee,
        {
          iconOnly: !0,
          $colorTheme: i,
          $isOpen: o,
          ariaLabel: c,
          className: f,
          disabled: d,
          onClick: x,
          ref: a.setReference,
          variant: "ghost",
          ...g(),
          children: /* @__PURE__ */ t.jsx(J, { name: b || "overflow-menu-vertical", size: "medium" })
        }
      );
    };
    return /* @__PURE__ */ t.jsxs(K, { className: f, "data-testid": "overflow-menu", id: C, ref: k, children: [
      L(),
      o ? /* @__PURE__ */ t.jsx(
        Q,
        {
          $colorTheme: i,
          $isShifted: G,
          $placement: P,
          $toggleAndMenuGap: T,
          ref: a.setFloating,
          style: z,
          ...D(),
          children: /* @__PURE__ */ t.jsx(X, { children: s && (s == null ? void 0 : s.length) && s.map((e, n) => {
            const B = n === s.length - 1;
            return te(e) ? /* @__PURE__ */ t.jsx(Z, { $colorTheme: i, $isLastItem: B, children: e.items.map((l) => /* @__PURE__ */ t.jsx(O, { children: /* @__PURE__ */ t.jsx(
              $,
              {
                ariaLabel: `Select "${l.label}"`,
                disabled: l.id === u,
                onClick: () => {
                  m || j(l.id), M(l), r(!1);
                },
                size: "medium",
                variant: "ghost",
                children: l.label
              }
            ) }, l.id)) }, e.id) : /* @__PURE__ */ t.jsx(O, { children: /* @__PURE__ */ t.jsx(
              $,
              {
                ariaLabel: `Select “${e.label}”`,
                disabled: e.id === u,
                onClick: () => {
                  m || j(e.id), M(e), r(!1);
                },
                size: "medium",
                variant: "ghost",
                children: e.label
              }
            ) }, e.id);
          }) })
        }
      ) : null
    ] });
  }
);
ie.displayName = "OverflowMenu";
export {
  ie as OverflowMenu
};
